import { Box, BoxProps, Typography } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { TableHeaderSkeleton } from './skeletons/TableHeaderSkeleton';

type Props = {
  title: string;
  subtitle?: string;
  rowCount?: number;
  withPadding?: boolean;
  loading?: boolean;
} & BoxProps;

export const TableHeader = ({ title, subtitle, rowCount, withPadding, loading = false, sx, ...rest }: Props) => {
  if (loading) {
    return <TableHeaderSkeleton title={title} subtitle={subtitle} withPadding={withPadding} />;
  }
  return (
    <Box data-role="table-header" {...rest} sx={withPadding ? deepmerge({ p: 2 }, sx) : sx}>
      <Typography variant="h5" component={'h2'} sx={{ fontWeight: 400 }}>
        {title}
        {!!rowCount && (
          <Box component="span" sx={{ fontSize: '0.65em', ml: 1 }}>
            ({rowCount})
          </Box>
        )}
      </Typography>
      {subtitle && (
        <Typography variant="subtitle1" sx={{ fontWeight: 400, fontSize: '0.875rem' }} color="textSecondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};
